
import HeaderSectionReusableComponent from "../../component/ReusablaeComponent/HeaderSectionReusableComponent";
import Image_ContentReusableComponent from "../../component/ReusablaeComponent/Image_ContentReusableComponent";
import HeadingParagraphSection from "../../component/ReusablaeComponent/HeadingParagraphSection";
import Constructions from '../../../Assets/Construstion.png'
import ConstructionManagement from '../../../Assets/Construction Management.png';
import ResidentionalArea from '../../../Assets/ResidentionalArea.png'
import Health_Safety from '../../../Assets/Health_Safety.png' 
import { Helmet } from 'react-helmet';

const Construction = () => {
  return (
    <div>
      <Helmet>
        <title>PT KCS | Construction Industry ERP & Project Management Solutions Indonesia – Jakarta</title>
        <meta name="description" content="PT KCS provides end-to-end construction management and ERP solutions for Indonesia's construction sector. From residential projects to large-scale commercial infrastructure — optimize cost, schedule, compliance, and safety." />
        <meta name="keywords" content="PT KCS, PT KCS Indonesia, construction ERP Jakarta, construction management software Indonesia, software manajemen konstruksi, ERP industri konstruksi Indonesia, project management software Indonesia, construction project tracking, infrastructure development ERP, civil engineering IT solutions, residential construction software, commercial construction management, health and safety compliance software Indonesia, IFCA ContractX, construction budgeting software, building information modeling BIM Indonesia, contract management software, subcontractor management ERP, material procurement software construction, construction payroll software, proyek konstruksi Indonesia, manajemen proyek digital, construction cost control software, real estate development ERP, property developer software Jakarta, construction progress monitoring, site management software Indonesia, ERP Surabaya konstruksi, ERP Bandung proyek, construction compliance Indonesia, Infor CloudSuite construction, SAP for construction Indonesia, builder ERP Indonesia, construction digital transformation, konstruksi teknologi informasi" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>
      <HeaderSectionReusableComponent
        mainHeading="Building the Future of Construction"
        paragragh={
          <>
            We provide innovative construction solutions that meet the demands
            of modern infrastructure projects. From residential developments to
            large-scale commercial construction, our expertise drives progress
            and efficiency.
          </>
        }
        imgScr={Constructions}
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        heading="End-to-End Construction Management"
        paragraph={
          <>
            Our comprehensive project management services cover every phase of
            construction, from planning and design to execution and delivery. We
            ensure that projects are completed on time, within budget, and to
            the highest quality standards.
          </>
        }
        imgsrc={ConstructionManagement}
      />
      <HeadingParagraphSection
        heading="Infrastructure Development"
        paragraph={
          <>
            With expertise in civil engineering and large-scale infrastructure,
            we deliver robust solutions for highways, bridges, tunnels, and
            public utilities. Our focus is on creating resilient infrastructure
            that supports economic growth and community development.
          </>
        }
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        reverse={false}
        heading="Residential and Commercial Projects"
        paragraph={
          <>
            From high-rise buildings to commercial complexes, our team delivers
            world-class construction services across a range of sectors. Whether
            it’s luxury residences or state-of-the-art office spaces, we bring
            expertise in architectural design and construction excellence.
          </>
        }
        imgsrc={ResidentionalArea}
      />
      <Image_ContentReusableComponent
      
        heading="Health & Safety Compliance"
        paragraph={
          <>
            We prioritize health and safety in every project we undertake. Our
            stringent safety protocols, coupled with regulatory compliance,
            ensure a safe working environment for all stakeholders involved in
            construction projects.
          </>
        }
        imgsrc={Health_Safety}
      />
    </div>
  );
};

export default Construction;
